<div class="pack-wrapper" *ngIf="packs&&packs?.length > 1">
    <div class="pack-container">
        <ul>
            <li *ngFor="let pack of packs">
                <a class="pack-item" [attr.href]="pack.link" [ngClass]="{'active': pack.code === 'IP' }" (click)="itemClick(pack)">{{pack.displayText}}</a>
            </li>
        </ul>
    </div>
</div>